/* eslint-disable */
import React, { useState } from 'react';
import DevsPop from './DevsPop';
import p from './devsPop.module.css';
import { Ic } from './devsIcons';
import { SORT_ITEMS } from './devsBarModel';

// The three small menus of the bar: Sort, Views, and ⋯ (More). In "More" the Views / Sort / View groups
// appear only while the bar has folded them (fold level >= 3, or a screen <= 1000px), so a folded control is
// always reachable.

const Check = () => <span className={p.ck}><Ic n="chk" /></span>;

export function SortMenu({ sort, onPick, onClose }) {
  return (
    <DevsPop anchorKey="sort" kind="mn" label="Sort" align="r" onClose={onClose}>
      <div className={p.mgrp}><div className={p.mh}>Sort by</div>
        {SORT_ITEMS.map((i) => <button key={i.key} type="button" data-nav className={`${p.mi} ${sort === i.key ? p.on : ''}`} aria-pressed={sort === i.key} onClick={() => onPick(i.key)}>{i.label}{sort === i.key && <Check />}</button>)}
      </div>
    </DevsPop>
  );
}

export function ViewsBody({ views, activeId, onApply, onDelete, onSave }) {
  const [name, setName] = useState('');
  const save = () => { const n = name.trim(); if (n) { onSave(n); setName(''); } };
  return (
    <>
      <div className={p.mgrp}><div className={p.mh}>Saved views · {views.length}</div>
        {views.map((v) => (
          <div key={v.id} className={`${p.vrow} ${activeId === v.id ? p.on : ''}`}>
            <button type="button" data-nav className={`${p.mi} ${p.vap}`} title={`Apply ${v.name}`} onClick={() => onApply(v)}><Ic n="bm" /><span className={p.vn}>{v.name}</span>{activeId === v.id && <Check />}</button>
            <span className={p.vac}><button type="button" className={`${p.vib} ${p.dl}`} aria-label={`Delete ${v.name}`} title="Delete" onClick={() => onDelete(v)}><Ic n="trash" /></button></span>
          </div>
        ))}
        {!views.length && <div className={p.none}>No saved views yet</div>}
      </div>
      <div className={p.vsave}>
        <input className={p.vin} value={name} maxLength={40} placeholder="Name this view…" aria-label="Name for the current filters" onChange={(e) => setName(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); save(); } }} autoFocus={!window.matchMedia('(max-width:760px)').matches} />
        <button type="button" className={p.done} disabled={!name.trim()} onClick={save}>Save</button>
      </div>
      <div className={p.vnote}>Saves every filter, stage, search and sort.</div>
    </>
  );
}

export function ViewsMenu({ onClose, ...body }) {
  return <DevsPop anchorKey="views" fallbackKey="more" kind="mn" label="Saved views" align="r" onClose={onClose}><ViewsBody {...body} /></DevsPop>;
}

export function MoreMenu({ folded, sort, onSort, views, activeViewId, onApplyView, onManageViews, density, onDensity, actions, onClose }) {
  const Group = ({ title, children }) => <div className={p.mgrp}><div className={p.mh}>{title}</div>{children}</div>;
  return (
    <DevsPop anchorKey="more" kind="mn" label="More actions" align="r" onClose={onClose}>
      {folded && <Group title="Saved views">
        {views.slice(0, 5).map((v) => <button key={v.id} type="button" data-nav className={`${p.mi} ${activeViewId === v.id ? p.on : ''}`} onClick={() => onApplyView(v)}><Ic n="bm" /><span className={p.vn}>{v.name}</span>{activeViewId === v.id && <Check />}</button>)}
        <button type="button" data-nav className={p.mi} onClick={onManageViews}><Ic n="pen" />Save or manage views…</button>
      </Group>}
      {folded && <Group title="Sort by">
        {SORT_ITEMS.map((i) => <button key={i.key} type="button" data-nav className={`${p.mi} ${sort === i.key ? p.on : ''}`} aria-pressed={sort === i.key} onClick={() => onSort(i.key)}>{i.label}{sort === i.key && <Check />}</button>)}
      </Group>}
      {folded && <Group title="View">
        {[['cards', 'grid', 'Cards'], ['compact', 'list', 'Compact']].map(([v, ic, l]) => <button key={v} type="button" data-nav className={`${p.mi} ${density === v ? p.on : ''}`} aria-pressed={density === v} onClick={() => onDensity(v)}><Ic n={ic} />{l}{density === v && <Check />}</button>)}
      </Group>}
      {actions.length > 0 && <Group title="Actions">
        {actions.map((a) => <button key={a.key} type="button" data-nav className={p.mi} onClick={a.onClick}><Ic n={a.icon} />{a.label}</button>)}
      </Group>}
    </DevsPop>
  );
}
